export class CurrencyBalanceData {
    currency: string;
    desk: string;
    balance: number;
}
